import React from 'react';
import { bigNumberToText } from '../../../../components/utils';

interface Props {
    total: number | string;
    diff?: number;
    isBlurred?: boolean;
}

const TotalColumn = ({ total, diff, isBlurred }: Props) => {
    return (
        <div className={`w-full h-full flex items-center gap-1 ${isBlurred ? 'opacity-20' : ''}`}>
            <span className="text-13 text-sf">{total.toLocaleString('en-US')}</span>
            {!!diff && (
                <span className="text-13 text-sf text-sf-primary-500">
                    ({`${diff > 0 ? '+' : ''}${bigNumberToText(diff)}`})
                </span>
            )}
        </div>
    );
};

export default TotalColumn;
